import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTextEdit"><Path d="M1.5 5.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M1.5 9.5H6.5" stroke="currentColor" strokeLinecap="square"/><Path d="M22.5 8.5L18.5 4.5L7.5 15.5V19.5H11.5L22.5 8.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconTextEdit;
